/**
 * 確認ダイアログ（03 5.4）：削除・一括削除・復元・API キーの再発行・テスト送信で使う。
 * 文言は MSG-C／FE-MSG-C。「キャンセル」（text）と実行ボタン（削除は error＝赤の contained。is_destructive は削除だけに付ける）。Esc・背景のクリックはキャンセル。
 * 実行ボタンは押したら閉じるまで押せない（03 3.8）。
 */
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useState } from 'react';
import { FE_MESSAGES } from '@pcrm/shared';

export interface ConfirmDialogProps {
  is_open: boolean;
  title?: string;
  message: string;
  confirm_label?: string;
  cancel_label?: string;
  is_destructive?: boolean;
  /** 実行の処理（省略時は閉じるだけ） */
  onConfirm?: () => Promise<void> | void;
  onClose: () => void;
}

export function ConfirmDialog(props: ConfirmDialogProps) {
  const { onConfirm, onClose } = props;
  const [is_running, setIsRunning] = useState(false);

  const confirm = async () => {
    if (is_running) {
      return;
    }
    setIsRunning(true);
    try {
      await onConfirm?.();
    } finally {
      setIsRunning(false);
      onClose();
    }
  };

  return (
    <Dialog
      open={props.is_open}
      onClose={() => (is_running ? undefined : onClose())}
      aria-labelledby="pcrm-confirm-title"
    >
      {props.title && <DialogTitle id="pcrm-confirm-title">{props.title}</DialogTitle>}
      <DialogContent>
        <Typography sx={{ whiteSpace: 'pre-line' }}>{props.message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="text" onClick={onClose} disabled={is_running}>
          {props.cancel_label ?? 'キャンセル'}
        </Button>
        <Button
          variant="contained"
          color={props.is_destructive ? 'error' : 'primary'}
          onClick={() => void confirm()}
          disabled={is_running}
          aria-label={is_running ? FE_MESSAGES['FE-MSG-I-014'].text : undefined}
        >
          {is_running ? <CircularProgress size={16} color="inherit" /> : (props.confirm_label ?? 'OK')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
